<input
  [type]="type"
  [(ngModel)]="model"
  [ngModelOptions]="{ standalone: true }"
  (keyup)="inputChanged()"
  class="form-control form-control-sm text-start"
/>
